var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('div',{staticClass:"card-header",staticStyle:{"cursor":"pointer"}},[_c('h4',{staticClass:"card-title"},[_vm._v(" Could not find anything")])])])}
var staticRenderFns = []

export { render, staticRenderFns }